import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const ScrollZoomControl = ({ setScrollZoomControlOverlayVisible, darkMode }) => {
  const map = useMap();
  
  useEffect(() => {
    try {
      const mapContainer = map.getContainer();
  
      const handleKeyDown = (e) => {
        if (e.key === 'Alt') {
          map.scrollWheelZoom.enable();
          setScrollZoomControlOverlayVisible(false);
        }
      };
  
      const handleKeyUp = (e) => {
        if (e.key === 'Alt') {
          map.scrollWheelZoom.disable();
        }
      };
  
      const handleWheelEvent = (e) => {
        if (!e.altKey) {
          setScrollZoomControlOverlayVisible(true);
        }
      };
  
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('keyup', handleKeyUp);
      mapContainer.addEventListener('wheel', handleWheelEvent);
  
      // Make the map container focusable
      mapContainer.tabIndex = 0;
  
      if (map.attributionControl) {
        const attributionElement = document.querySelector('.leaflet-control-attribution');
        if (attributionElement) {
          attributionElement.innerHTML = `<span class="${darkMode ? "custom-attribution-dark" : "custom-attribution"}">&copy; Esri &mdash; Sources: Esri, DigitalGlobe, Earthstar Geographics, CNES/Airbus DS, GeoEye, USDA FSA, USGS, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community</span>`;
        };
      };
      // if (map.attributionControl) {
      //   map.attributionControl.remove();
      //   map.attributionControl.setPrefix(false);
      //   map.attributionControl.addAttribution(
      //     `<span class=${darkMode ? "custom-attribution-dark" : "custom-attribution"}>&copy; Esri &mdash; Sources: Esri, DigitalGlobe, Earthstar Geographics, CNES/Airbus DS, GeoEye, USDA FSA, USGS, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community</span>`
      //   );
      // };
      
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('keyup', handleKeyUp);
        mapContainer.removeEventListener('wheel', handleWheelEvent);
      };
    } catch (error) {
      console.log(error)
    }
  }, [darkMode, map, setScrollZoomControlOverlayVisible]);

  return null;
};

export default ScrollZoomControl;